import styled from 'styled-components';

export const Container = styled.div`
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
`;

export const PaymentsPanel = styled.div`
  background-color: ${({ theme }) => theme.background_primary};
  width: 100%;
  border-radius: 0.25rem;
  padding: 1.5rem;
  margin-right: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  .loading {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .tableActions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const BrandsPanel = styled.div`
  background-color: ${({ theme }) => theme.background_primary};
  width: 100%;
  border-radius: 0.25rem;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  .loading {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .tableActions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const PaymentsTable = styled.div`
  margin-top: 1.5rem;
  width: 100%;

  .header {
    border-top: 0.063rem solid ${({ theme }) => theme.background_secondary};
    border-bottom: 0.063rem solid ${({ theme }) => theme.background_secondary};
    padding: 0.5rem 1rem;
    display: grid;
    grid-template-columns: 0.5fr repeat(2, 1fr) 0.5fr;

    p {
      border: none;
      padding: 0;
      font-weight: 700;
    }
  }

  .rowTable {
    padding: 0.5rem 1rem;
    display: grid;
    grid-template-columns: 0.5fr repeat(2, 1fr) 0.5fr;
    border-bottom: 0.063rem solid ${({ theme }) => theme.background_secondary};

    button:first-child {
      color: ${({ theme }) => theme.button_success};
      font-size: 2rem;
      display: flex;
      align-items: center;
    }

    button:last-child {
      color: ${({ theme }) => theme.button_primary};
      font-size: 1.5rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
`;

export const BrandsTable = styled.div`
  margin-top: 1.5rem;
  width: 100%;

  img {
    border-radius: 100%;
    width: 2.5rem;
    height: 2.5rem;
  }

  .header {
    border-top: 0.063rem solid ${({ theme }) => theme.background_secondary};
    border-bottom: 0.063rem solid ${({ theme }) => theme.background_secondary};
    padding: 0.5rem 1rem;
    display: grid;
    grid-template-columns: 0.5fr repeat(4, 1fr) 0.5fr;

    p {
      border: none;
      padding: 0;
      font-weight: 700;
    }
  }

  .rowTable {
    padding: 0.5rem 1rem;
    display: grid;
    grid-template-columns: 0.5fr repeat(4, 1fr) 0.5fr;
    border-bottom: 0.063rem solid ${({ theme }) => theme.background_secondary};

    button:first-child {
      color: ${({ theme }) => theme.button_success};
      font-size: 2rem;
      display: flex;
      align-items: center;
    }

    button:last-child {
      color: ${({ theme }) => theme.button_primary};
      font-size: 1.5rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
`;

export const Pill = styled.p`
  background-color: ${props => props.color};
  padding: 0.25rem 0.625rem;
  border-radius: 1rem;
  margin: 0.25rem;
  width: fit-content;
`;
